import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "mersa_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      const t = window.setTimeout(() => setVisible(true), 800);
      return () => window.clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="container-wide flex flex-col gap-3 py-4 md:flex-row md:items-center md:justify-between md:gap-6">
        <p className="text-sm text-muted-foreground">
          Sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. Detaylı bilgi için{" "}
          <Link to="/cerez-politikasi" className="underline hover:text-foreground">
            Çerez Politikası
          </Link>
          {" "}ve{" "}
          <Link to="/kvkk-aydinlatma" className="underline hover:text-foreground">
            KVKK Aydınlatma Metni
          </Link>
          {" "}sayfalarımızı inceleyebilirsiniz.
        </p>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={decline}>Reddet</Button>
          <Button size="sm" onClick={accept}>Kabul Et</Button>
        </div>
      </div>
    </div>
  );
}
